// Angular
import { Component } from '@angular/core';

// Formly
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'formly-field-text',
    templateUrl: './text.type.component.html',
})
export class FormlyFieldText extends FieldType {
    get type() {
        return this.to.type || 'text';
    }

    private get(path, obj) {
        let paths = path.split('.');
        let current = obj;
        let i;

        for (i = 0; i < paths.length; ++i) {
            if (current[paths[i]] === undefined) {
                return undefined;
            } else {
                current = current[paths[i]];
            }
        }

        return current;
    }
}
